<template>
  <v-container style="max-width: 1140px;">
    <h1 class="display-1 mb-3">FAQ</h1>

    <h3>What is a Walk Audit?</h3>
    <p>A walk audit is an evaluation of the environmental conditions, such as buildings, sidewalks, and parks, which can impact the walkability of a particular geographic area. Walk audits can be conducted by public employees, engineering firms, and community members. Once completed, walk audits can help stakeholders identify and correct issues which affect pedestrian accessibility.</p>

    <h3>What factors can impact walkability?</h3>
    <p>Built and natural conditions can impact the walkability of a neighborhood. Features such as street lighting, sidewalks, bicycle lanes and paths, etc. can affect the ability for a pedestrian to safely and easily navigate an area.</p>

    <h3>What is the Project Timeline?</h3>
    <p>In the coming months, we will identify volunteers, disseminate information, and conduct the walk audits. Audits will take place in September, with next steps including</p>
    <ul class="mb-3">
      <li>Compile recommendations and submit report to LADOT</li>
      <li>Develop bicycle and pedestrian maps for Warner Center</li>
    </ul>

  <v-img
    align-top
    width="100%"
    src="img/hero/DSC02807.jpg"
    gradienta="to top right, rgba(100,115,201,.43), rgba(25,32,72,.7)">
  </v-img>    
  </v-container>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>

</style>